import { ReactNode } from 'react';

import type { Announcement } from '@types';

import { Carousel } from '../components/carousel';
import { RichText } from '../components/rich-text';

export async function AnnouncementWrapper({ children }: { children: ReactNode }) {
  // this is needed for the announcement banner to sit correctly with the navigation and be hidden on scroll
  return <div className="z-50 -mb-8 flex w-full sm:-mb-20">{children}</div>;
}

export async function AnnouncementSlide({
  content,
  backgroundColour,
  foregroundColour,
}: {
  content: string;
  backgroundColour?: string;
  foregroundColour?: string;
}) {
  return (
    <div
      className="bg-accent text-accent-foreground flex h-12 w-full items-center justify-center px-4 text-center select-none"
      style={{ color: foregroundColour, backgroundColor: backgroundColour }}
    >
      <RichText className="line-clamp-2 max-w-(--breakpoint-2xl)! text-xs! sm:text-sm! sm:leading-tight!">
        {content}
      </RichText>
    </div>
  );
}

export async function AnnouncementBar({ announcements }: { announcements?: Announcement[] }) {
  if (!announcements?.[0]?.content) return null;

  if (announcements?.length === 1) {
    const { backgroundColour, foregroundColour, content } = announcements?.[0] || {};

    return (
      <AnnouncementWrapper>
        <AnnouncementSlide
          backgroundColour={backgroundColour}
          foregroundColour={foregroundColour}
          content={content?.content || ''}
        />
      </AnnouncementWrapper>
    );
  }

  return (
    <AnnouncementWrapper>
      <Carousel
        autoPlayDuration={3500}
        hideButtons
        hidePagination
        classNames={{
          carouselItem: 'pl-0 sm:pl-0',
        }}
        items={announcements.filter(Boolean).map(({ backgroundColour, content, foregroundColour }) => (
          <AnnouncementSlide
            key={content?.content}
            backgroundColour={backgroundColour}
            foregroundColour={foregroundColour}
            content={content?.content || ''}
          />
        ))}
      />
    </AnnouncementWrapper>
  );
}
